'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./cjs/value-equal.min.js');
} else {
  module.exports = require('./cjs/value-equal.js');
}



//////////////////
// WEBPACK FOOTER
// /data/www/SGDBackend-Nex2/~/value-equal/index.js
// module id = 714
// module chunks = 0